// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__KuhVv","fixedbutton":"style_fixedbutton__Q03uS"};